const initialState = {
    cmpId:"",
    abrVal:"",
    cVal:"",    
    AddressId:"",
    addressLine1:"",
    addressLine2:"",
    Zip:"",
    City:"",
    State:"",
    Doid:"",
    Intent:"",
    productType:"",
    vendorResponse:null,
    vendorDescription:"",
    visitId: "",
    visitorId: "",
    Vcustid: "",
    Vactid: "0001",
    State: "",
    locationCode: "",
    dataId: "",
    dataName: "",
    tvId: "",
    tvName: "",
    extraId: "",
    extraName: "",
    outletId: ""
}

function testPage(state = initialState, action) {
    switch (action.type) {    	
        case 'TESTPAGE_VALIDATEINPUT':
            return Object.assign({}, state, {
                visitId: action.value.visitId !== undefined && 
                    action.value.visitId !== state.visitId ? action.value.visitId : state.visitId,
                visitorId: action.value.visitorId !== undefined && 
                    action.value.visitorId !== state.visitorId ? action.value.visitorId : state.visitorId,
                Vcustid: action.value.Vcustid !== undefined && 
                    action.value.Vcustid !== state.Vcustid ? action.value.Vcustid : state.Vcustid,
                Vactid: action.value.Vactid !== undefined && 
                    action.value.Vactid !== state.Vactid ? action.value.Vactid : state.Vactid,
                cmpId: action.value.cmpId !== undefined &&
                    action.value.cmpId !== state.cmpId ? action.value.cmpId : state.cmpId,
                abrVal: action.value.abrVal !== undefined &&
                    action.value.abrVal !== state.abrVal ? action.value.abrVal : state.abrVal,
                cVal: action.value.cVal !== undefined &&
                    action.value.cVal !== state.cVal ? action.value.cVal : state.cVal,
                AddressId: action.value.AddressId !== undefined &&
                    action.value.AddressId !== state.AddressId ? action.value.AddressId : state.AddressId,
                addressLine1: action.value.addressLine1 !== undefined &&
                    action.value.addressLine1 !== state.addressLine1 ? action.value.addressLine1 : state.addressLine1,
                addressLine2: action.value.addressLine2 !== undefined &&
                    action.value.addressLine2 !== state.addressLine2 ? action.value.addressLine2 : state.addressLine2,
                Zip: action.value.Zip !== undefined &&
                    action.value.Zip !== state.Zip ? action.value.Zip : state.Zip,
                City: action.value.City !== undefined &&
                    action.value.City !== state.City ? action.value.City : state.City,
                State: action.value.State !== undefined &&
                    action.value.State !== state.State ? action.value.State : state.State,
                Doid: action.value.Doid !== undefined &&
                    action.value.Doid !== state.State ? action.value.Doid : state.Doid,
                Intent: action.value.Intent !== undefined &&
                    action.value.Intent !== state.State ? action.value.Intent : state.Intent,
                productType: action.value.productType !== undefined &&
                    action.value.productType !== state.productType ? action.value.productType : state.productType,
                locationCode: action.value.locationCode !== undefined &&
                    action.value.locationCode !== state.locationCode ? action.value.locationCode : state.locationCode,
                dataId: action.value.dataId !== undefined &&
                    action.value.dataId !== state.dataId ? action.value.dataId : state.dataId, 
                dataName: action.value.dataName !== undefined &&
                    action.value.dataName !== state.dataName ? action.value.dataName : state.dataName, 
                tvId: action.value.tvId !== undefined &&
                    action.value.tvId !== state.tvId ? action.value.tvId : state.tvId, 
                tvName: action.value.tvName !== undefined &&
                    action.value.tvName !== state.tvName ? action.value.tvName : state.tvName, 
                extraId: action.value.extraId !== undefined &&
                    action.value.extraId !== state.extraId ? action.value.extraId : state.extraId, 
                extraName: action.value.extraName !== undefined &&
                    action.value.extraName !== state.extraName ? action.value.extraName : state.extraName,
                outletId: action.value.outletId !== undefined &&
                    action.value.outletId !== state.outletId ? action.value.outletId : state.outletId,    
                           
            })
        case 'VENDOR_RESPONSE':
            return Object.assign({}, state, {
                vendorResponse: action.value
            })
        case 'VENDOR_DESCRIPTION_TESTPAGE':
            return Object.assign({}, state, {
                vendorDescription: action.value
            })
        default:
              return state
    }
}
export default testPage